interface YouTubeEmbedProps {
    videoId: string
}

export default function YouTubeEmbed({ videoId }: YouTubeEmbedProps) {
    return (
        <div className="my-2 max-w-md">
            <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                className="w-full aspect-video rounded-lg"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    )
}
